import { defineStore } from 'pinia';
import resultado_produccion_service from '@/services/resultado_produccion_service';
import { resultado_produccion_model } from '../models/resultado_produccion_model';

export const useResultadoProduccionStore = defineStore('resultadoProduccionStore', {
  state: () => ({
    resultado: JSON.parse(JSON.stringify(resultado_produccion_model)),
    resultadoDetalle: null,
    isStale: false,
    loading: false,
    error: null,
    cantidadSeleccionada: null,
    cantidades: [],
  }),

  getters: {
    tieneMultiplesCantidades: (state) => {
      return state.cantidades.length > 1;
    },

    cantidadActual: (state) => {
      if (!state.cantidadSeleccionada) return null;
      return state.cantidades.find(
        (c) => c.codigoCotizacionCantidad === state.cantidadSeleccionada,
      );
    },

    datosProducto: (state) => {
      return state.resultadoDetalle?.producto || null;
    },

    datosCantidad: (state) => {
      return state.resultadoDetalle?.cantidadDatos || null;
    },

    datosProductoCompletos: (state) => {
      if (!state.resultadoDetalle?.producto) return null;
      return {
        producto: state.resultadoDetalle.producto,
        cantidadDatos: state.resultadoDetalle.cantidadDatos || null,
      };
    },

    procesos: (state) => {
      return state.resultadoDetalle?.procesos || [];
    },

    materiales: (state) => {
      return state.resultadoDetalle?.materiales || [];
    },

    fechaCalculo: (state) => {
      return state.resultadoDetalle?.fechaCalculo || null;
    },
  },

  actions: {
    async fetchResultadosHTTP(codigoCotizacion) {
      this.loading = true;
      this.error = null;

      try {
        const data = await resultado_produccion_service.obtenerResultados(codigoCotizacion);

        this.resultado = {
          codigoCotizacion: data.codigoCotizacion,
          isStale: data.isStale,
          cantidades: data.cantidades || [],
        };

        this.isStale = data.isStale;
        this.cantidades = (data.cantidades || []).map((c) => ({
          codigoCotizacionCantidad: c.codigoCotizacionCantidad,
          cantidad: c.cantidad,
          unidadVenta: c.unidadVenta,
          fechaCalculo: c.fechaCalculo,
        }));

        if (this.cantidades.length > 0 && !this.cantidadSeleccionada) {
          this.cantidadSeleccionada = this.cantidades[0].codigoCotizacionCantidad;
          await this.fetchResultadoPorCantidadHTTP(codigoCotizacion, this.cantidadSeleccionada);
        }
      } catch (error) {
        console.error('[STORE] ❌ Error en fetchResultadosHTTP:', error);
        this.error = error.message || 'Error al obtener cálculos productivos';
      } finally {
        this.loading = false;
      }
    },

    async fetchResultadoPorCantidadHTTP(codigoCotizacion, codigoCantidad) {
      this.loading = true;
      this.error = null;

      try {
        const data = await resultado_produccion_service.obtenerResultadoPorCantidad(
          codigoCotizacion,
          codigoCantidad,
        );

        this.resultadoDetalle = {
          codigoCotizacionCantidad: data.codigoCotizacionCantidad,
          fechaCalculo: data.fechaCalculo,
          producto: data.producto,
          cantidadDatos: data.cantidadDatos,
          procesos: data.procesos || [],
          materiales: data.materiales || [],
        };

        this.isStale = data.isStale;
        this.cantidadSeleccionada = codigoCantidad;
      } catch (error) {
        console.error('[STORE] ❌ Error en fetchResultadoPorCantidadHTTP:', error);
        this.error = error.message || 'Error al obtener detalle de cantidad';
      } finally {
        this.loading = false;
      }
    },

    setCantidadSeleccionada(codigoCantidad) {
      this.cantidadSeleccionada = codigoCantidad;
    },

    reset() {
      this.resultado = JSON.parse(JSON.stringify(resultado_produccion_model));
      this.resultadoDetalle = null;
      this.isStale = false;
      this.loading = false;
      this.error = null;
      this.cantidadSeleccionada = null;
      this.cantidades = [];
    },
  },
});
